<template>
  <div class="vue-treeselect__tip vue-treeselect__loading-tip inline-block">
    <div class="vue-treeselect__icon-container"><span class="vue-treeselect__icon-loader"></span></div>
    <span class="vue-treeselect__tip-text vue-treeselect__loading-tip-text">Loading...</span>
  </div>
</template>

<script>
export default {}
</script>